import http from './http';

export const getUserTrips = async () => {
  const res = await http.get('/customer/trips/get-user-trips');
  return res?.data;
};
